import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import firebase from '../../firebase/firebaseConfig';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  button: {
    marginBottom: '50px',
  },
}));

const AdminOthers = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleSignOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Sign-out successful.
        history.push('/');
      })
      .catch((error) => {
        // An error happened.
        console.log('Sign out error: ' + error);
      });
  };

  return (
    <div>
      <h2>Others</h2>
      <Button
        className={classes.button}
        variant='contained'
        color='secondary'
        onClick={handleSignOut}
      >
        Logout
      </Button>{' '}
    </div>
  );
};

export default AdminOthers;
